import { FC, memo } from 'react'

import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect, Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter'
import { TableFilterRow } from 'ui/temp/TableFilterRow'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import * as SC from './styles'

export const Filter: FC = memo(() => {
  const { data, search, onFilterChange } = useAlertsContext()
  const { uploadsTypeOptions, relationshipOptions, form } = data

  const formApi = useForm({
    defaultValues: {
      uploadsType: form.uploadsType,
      uploadsCompanyID: form.uploadsCompanyID
    }
  })

  const clearForm = () => {
    formApi.reset()
    onFilterChange(
      {
        uploadsType: undefined,
        uploadsCompanyID: undefined,
        uploadsPage: 1
      },
      'uploads'
    )
  }

  const updateSearchParams = (newValue: Partial<AlertsPayload>) => {
    onFilterChange({ ...search, ...newValue, uploadsPage: 1 }, 'uploads')
  }

  const hasActiveFilters = Boolean(search.uploadsType || search.uploadsCompanyID)

  return (
    <FilterPanel isDirty={hasActiveFilters} onReset={clearForm} expanded={false}>
      <FilterWrapper>
        <TableFilterRow>
          {uploadsTypeOptions?.length > 1 && (
            <SC.ItemWrapper>
              <formApi.Field
                name="uploadsType"
                listeners={{
                  onChange: ({ value }) => {
                    updateSearchParams({ uploadsType: value })
                  }
                }}
                children={(field) => (
                  <FF
                    field={field}
                    label="Type"
                    input={(inputProps) => <Select data={uploadsTypeOptions} {...inputProps} />}
                  />
                )}
              />
            </SC.ItemWrapper>
          )}
          <SC.ItemWrapper>
            <formApi.Field
              name="uploadsCompanyID"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ uploadsCompanyID: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Relationship"
                  input={(inputProps) => (
                    <CompanySelect
                      hideMyCompaniesFilter
                      preloadedOptions={relationshipOptions}
                      data-qa="Relationships Type"
                      options-data-qa="Relationships"
                      {...inputProps}
                    />
                  )}
                />
              )}
            />
          </SC.ItemWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
})
